/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ValidateWorkflowModelSchemaRequest,
} from '../models/index';
import {
    ValidateWorkflowModelSchemaRequestFromJSON,
    ValidateWorkflowModelSchemaRequestToJSON,
} from '../models/index';

export interface GetWorkflowModelSchemasRequest {
    type?: GetWorkflowModelSchemasTypeEnum;
}

export interface ValidateWorkflowModelSchemaOperationRequest {
    validateWorkflowModelSchemaRequest: ValidateWorkflowModelSchemaRequest;
}

/**
 * 
 */
export class SchemaApi extends runtime.BaseAPI {

    /**
     * ワークフローモデルのJSON Schemaを返す。typeを指定すると部分取得できる。
     */
    async getWorkflowModelSchemasRaw(requestParameters: GetWorkflowModelSchemasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/schemas/model`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * ワークフローモデルのJSON Schemaを返す。typeを指定すると部分取得できる。
     */
    async getWorkflowModelSchemas(requestParameters: GetWorkflowModelSchemasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getWorkflowModelSchemasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフローモデルの definition / dataSchema / policy を JSON Schema に対してバリデーションする。モデルの公開前に使用する。
     */
    async validateWorkflowModelSchemaRaw(requestParameters: ValidateWorkflowModelSchemaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['validateWorkflowModelSchemaRequest'] == null) {
            throw new runtime.RequiredError(
                'validateWorkflowModelSchemaRequest',
                'Required parameter "validateWorkflowModelSchemaRequest" was null or undefined when calling validateWorkflowModelSchema().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/schemas/model/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateWorkflowModelSchemaRequestToJSON(requestParameters['validateWorkflowModelSchemaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * ワークフローモデルの definition / dataSchema / policy を JSON Schema に対してバリデーションする。モデルの公開前に使用する。
     */
    async validateWorkflowModelSchema(requestParameters: ValidateWorkflowModelSchemaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.validateWorkflowModelSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetWorkflowModelSchemasTypeEnum = {
    Definition: 'definition',
    DataSchema: 'dataSchema',
    DataAccessPolicy: 'dataAccessPolicy'
} as const;
export type GetWorkflowModelSchemasTypeEnum = typeof GetWorkflowModelSchemasTypeEnum[keyof typeof GetWorkflowModelSchemasTypeEnum];
